// extracted by mini-css-extract-plugin
var _1 = "content__dzDcK";
export { _1 as "content" }
